import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './HtmlEditor.html?raw';
import _TabEnabledMixin from '../Tabbing/_TabEnabledMixin';
import topic from 'dojo/topic';
import { CountryCode2, CountryCodeIti, LanguagesGerman, PitLanguageMap, PitLanguageSuffix, PitLanguageSuffixes } from "../MultiLangEdit/TranslationsForm/TranslationsFormTypes";
import FloatingMenu from '../Floating/Menu';
import { ExtraHelpers, FeatureHelpers } from "../../../more/Helpers";


class HtmlEditor extends compose(_TabEnabledMixin) {
    //pro-tip: zum debuggen des editors filters kann der "source" button enabled werden mithilfe von -> feature "SCeditorFeatureDebugShowSource"

    templateString: any = template;

    private inputHtmlContent: HTMLTextAreaElement;
    private inputContainer: HTMLDivElement;

    private htmlContentData: string;// EmailEditorTypes.MailFormData;

    private sceWasInitialized: boolean = false;

    private sceDomID: string;

    private flagEnableFocusBorder: boolean = false;

    private originalData: string = "";

    public enableTextPasteFiltering: boolean = true;

    private showTranslationButton: boolean = false; //default ist false, da wir den button eigentlich nur im email editor haben wollen...

    public constructor(content?: string) {
        super(...(arguments as unknown as []));
        if (typeof content == 'string') {
            this.htmlContentData = content;
        }

        if (!content) {
            this.htmlContentData = "";
        }
    }



    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    //#region postCreate
    postCreate(): void {
        this.setupEditor().then(() => {
            this.inputHtmlContent.addEventListener("keydown", lang.hitch(this, this._onChange_InputValue));
            this.inputHtmlContent.addEventListener("input", lang.hitch(this, this._onChange_InputValue));
            this.inputHtmlContent.addEventListener("focusin", lang.hitch(this, this.SCloadEditor));
            this.inputHtmlContent.addEventListener("mouseover", lang.hitch(this, this.SCloadEditor));


            setTimeout(lang.hitch(this, this.SCloadEditor), 100);

            if (this.htmlContentData !== null) {
                this.RenderText();
            }
            //laded die custom buttons
            this.SChelper_AddCustomTooltips();
            //hotfix checker fuer multiple sceinstances
            this.sce_observer_fix_multpl_inst.observe(this.inputContainer, { attributes: false, childList: true, subtree: false });
            //reload fuer das dark theme
            topic.subscribe("Theme/Change", lang.hitch(() => {
                if (this.sceWasInitialized == true) {
                    this.close();
                    this.show();
                }
            }));
        })

    }

    private _onChange_Keydown(evt?: any) {
        setTimeout(lang.hitch(this, this._onChange_InputValue), 1000);
    }

    private _onChange_InputValue(evt?: any) {
        if (evt) this.htmlContentData = (evt.target as HTMLTextAreaElement).value;
        if (this.htmlContentData == "<br>" || this.htmlContentData == "<p><br></p>" || this.htmlContentData == "<p>&nbsp;<br></p>") {
            this.htmlContentData = "";
            this.scInstance.val("");
            if (evt) {
                (evt.target as HTMLTextAreaElement).value = "";
            }
        }
        this.emit("valueChange", this.htmlContentData);
        this.emit("change", this.htmlContentData);
    }

    setHtmlContent(content: string, suppressChangeEvent?: boolean) {
        let oldVal = this.htmlContentData;
        this.htmlContentData = content;

        if (oldVal != content) {
            if (suppressChangeEvent !== true) {
                this._onChange_InputValue();
            }
        }
        this.RenderText();
    }

    addHtmlContent(content: string, suppressChangeEvent?: boolean) {
        let oldVal = this.htmlContentData ? this.htmlContentData : "";
        let newVal = oldVal + content;

        this.htmlContentData = newVal;

        if (!suppressChangeEvent) {
            this._onChange_InputValue();
        }

        this.RenderText();
    }

    // wird vor dem speichern nocheinmal aufgerufen
    public updateContentData() {
        if (this.sceWasInitialized === true) {
            this.SC_onInput();
        }
    }


    getHtmlContent(): string {
        let dat = this.htmlContentData;
        return dat;
    }


    private RenderText() {
        if ((this.htmlContentData !== null) && (typeof this.htmlContentData !== 'undefined')) {
            this.inputHtmlContent.value = this.htmlContentData;
            try {
                this.scInstance.val(this.inputHtmlContent.value)
            } catch { }
        }

    }

    //#region SC-editor stuff

    // SCloadEditor()
    private scInstance: any;

    // SConInput()
    private SChelper_elementListToCheck: Array<HTMLElement> = [];

    // isVisible() / isHidden()
    flagEditorIsVisible: boolean = true;

    // SChelper_observerPostCreate()
    flagEditorExistsInDom: boolean = true;
    scDomObserver: IntersectionObserver;

    // beschreibt die FONTs fuer die Toolbar UND den filter beim einfuegen.
    editorOptionsAllowedFonts: Array<string> = ["Arial", "Arial Black", "Comic Sans MS", "Courier New", "Georgia", "Impact", "Sans-serif", "Serif", "Times New Roman", "Trebuchet MS", "Verdana", "Cascadia Mono"];

    private SCloadEditor() {

        // setzt sprache
        let ceSetLocal = "en";
        if (window.currentLanguageCode2 == "de") {
            ceSetLocal = "de";
        }
        if (window.currentLanguageCode2 == "id") {
            ceSetLocal = "it";
        }

        // laded ein anderes stylesheet fuer den dark mode, da man ansonsten den body nicht stylen kann
        let editorStyleSheet = window.appRoot + 'Content/sceditor/editor-theme_square.min.css'
        if (window.themeToggler.isDarkTheme()) {
            editorStyleSheet = window.appRoot + 'Content/sceditor/editor-theme_dark_square.min.css';
        }
        // versteckt das iframe, während sceditor initzialisiert, weil man ansonsten im darkMode geflashbanged wird
        this.inputContainer.style.visibility = "hidden";
        this.sceDomID = "mailEditorSC" + "_" + this.id;
        //@ts-expect-error
        sceditor.create(this.inputHtmlContent, { // pro-tip: das aendern der toolbar kann zu viel schmerzen fuehren
            toolbar: "bold,italic,underline,strike,subscript,superscript|left,center,right,justify|font,size,color,headingspresets,removeformat|cut,copy,paste,pastetext|bulletlist,orderedlist,table,code,quote,horizontalrule|email,link,unlink,date,time|ltr,rtl|maximize|editorcleanup|translate|source",
            fonts: this.editorOptionsAllowedFonts.join(","),
            emoticonsEnabled: false,
            autoExpand: true,
            autoupdate: true,
            resizeEnabled: false,
            resizeWidth: true,
            resizeHeight: false,
            resizeMinWidth: -1,
            resizeMaxWidth: -1,
            resizeMaxHeight: -1,
            spellcheck: true,
            locale: ceSetLocal,
            plugins: "undo,dragdrop,plaintext",
            enablePasteFiltering: true,
            id: this.sceDomID,
            format: 'xhtml',
            style: editorStyleSheet,
            dragdrop: {
                allowedTypes: ['image/jpeg', 'image/png'],
                handlePaste: true,
            },
            parserOptions: ["removeEmptyTags"],
            pastetext: {
                addButton: true,
                enabled: true
            },
        });
        //un-hide text field
        let targetFrame = this.inputContainer.getElementsByTagName("iframe")[0];
        if ((targetFrame.contentDocument || targetFrame.contentWindow.document).readyState == "complete") {
            //wenn, aus welchen grund auch immer, das iframe bereits geladen hat, wird es sofort sichtbar gemacht
            this.SChelper_afterLoad();
        } else {
            targetFrame.addEventListener("load", lang.hitch(this, this.SChelper_afterLoad));
        }

    }

    //#region sc afterLoad
    private SChelper_afterLoad() {
        this.inputContainer.style.visibility = "";
        this.UiModder.domClass.remove(this.inputContainer, "egoAnimated_fadingHourglassOverlay");
        //@ts-expect-error
        this.scInstance = sceditor.instance(this.inputHtmlContent);
        let scBody: HTMLBodyElement = this.scInstance.getBody();
        this.inputHtmlContent.style.display = "none"; //versteckt das textfeld, weil screen-reader und so
        //this.scInstance.bind("input", lang.hitch(this, this.SConInput));
        //this.scInstance.bind("contextmenu", lang.hitch(this, this.SConInput));
        //this.scInstance.bind("paste", lang.hitch(this, this.SConInput));
        //on focus out wurde entfernt, da es mit dem filter probleme gemacht hat
        //scBody.addEventListener("focusout", lang.hitch(this, this.SConInput));
        scBody.addEventListener("focusout", lang.hitch(this, this.SChelper_checkIfDirty));
        scBody.addEventListener("keydown", lang.hitch(this, this._onBodyKeydown));
        //scBody.addEventListener("paste", lang.hitch(this, this.SConInput));
        this.sceWasInitialized = true;
        if (this.flagEnableFocusBorder === true) {
            scBody.addEventListener("focusin", lang.hitch(this, this.editorBorderShow));
            scBody.addEventListener("focusout", lang.hitch(this, this.editorBorderHide));
        }
        //erstellt kopie um spaeter aenderungen festzustellen
        this.markFormAsWasSaved();
        //versteckt den "source" button aus der toolbar
        if (this.hasFeature("Email_Editor", "SCeditorFeatureDebugShowSource") == false) { //weils feiner zum debuggen des editors ist
            let sourceButtons = this.domNode.getElementsByClassName("sceditor-button-source");
            for (let elem of sourceButtons as any) {
                if ((elem as HTMLButtonElement).classList.contains("w3-hide") === false) {
                    (elem as HTMLButtonElement).classList.add("w3-hide");
                }
            }
        }
        this.domNode.getElementsByClassName("sceditor-toolbar")[0].addEventListener("click", lang.hitch(this, this.SChelper_overWriteToolBoxButtonStyle));
        //feature set
        const featureList = {
            "SCeditorFeatureTextFormatting": "div.sceditor-group a.sceditor-button-bold, div.sceditor-group a.sceditor-button-italic, div.sceditor-group a.sceditor-button-underline, div.sceditor-group a.sceditor-button-strike, div.sceditor-group a.sceditor-button-subscript, div.sceditor-group a.sceditor-button-superscript",
            "SCeditorFeatureTextAlignment": "div.sceditor-group a.sceditor-button-left, div.sceditor-group a.sceditor-button-center, div.sceditor-group a.sceditor-button-right, div.sceditor-group a.sceditor-button-justify",
            "SCeditorFeatureFontAndStyle": "div.sceditor-group a.sceditor-button-font, div.sceditor-group a.sceditor-button-size, div.sceditor-group a.sceditor-button-color, div.sceditor-group a.sceditor-button-headingspresets, div.sceditor-group a.sceditor-button-removeformat",
            "SCeditorFeatureClipboardAction": "div.sceditor-group a.sceditor-button-cut, div.sceditor-group a.sceditor-button-copy, div.sceditor-group a.sceditor-button-paste, div.sceditor-group a.sceditor-button-pastetext",
            "SCeditorFeatureListAndCode": "div.sceditor-group a.sceditor-button-bulletlist, div.sceditor-group a.sceditor-button-orderedlist, div.sceditor-group a.sceditor-button-table, div.sceditor-group a.sceditor-button-code, div.sceditor-group a.sceditor-button-quote, div.sceditor-group a.sceditor-button-horizontalrule",
            "SCeditorFeatureMediaAndLinks": "div.sceditor-group a.sceditor-button-email, div.sceditor-group a.sceditor-button-link, div.sceditor-group a.sceditor-button-unlink, div.sceditor-group a.sceditor-button-date, div.sceditor-group a.sceditor-button-time",
            "SCeditorFeatureTextDirection": "div.sceditor-group a.sceditor-button-ltr, div.sceditor-group a.sceditor-button-RTL",
            "SCeditorFeatureWindowAction": "div.sceditor-group a.sceditor-button-maximize",
            "SCeditorFeatureEditorCleanup": "div.sceditor-group a.sceditor-button-editorcleanup"
        };

        // RL: die Html-Editor-Flags sollten nicht im Email-Editor-Modul stehen
        // damit das kompatibel bleibt, abfragen welches der beiden Module in den Customersettings steht
        let module = FeatureHelpers.getModule("Html_Editor"); // wenn möglich, das Modul Html_Editor verwenden
        //if (!module) FeatureHelpers.getModule("Email_Editor"); // falls es das nicht gibt, stehtn die Einstellungen noch als Legacy im Email_Editor
        //let targetModule = module ? module.name : "unknownModule";

        // falls es das HTML-Modul nicht gibt, dann davon ausgehen dass wir eh alle Toolbar-Features davon verwenden wollen
        if (module) {
            let targetModule = module.name;
            for (let feature in featureList) {
                if (this.hasFeature(targetModule, feature) == false) {
                    let targetElem: HTMLDivElement = this.domNode.querySelector(featureList[feature]);
                    targetElem = targetElem.parentNode as HTMLDivElement;
                    targetElem.classList.add("w3-hide");
                }
            }
        }

        //extra funktionen
        this.setShowTranslationButton(this.showTranslationButton);//default ist false

        let iframeBody:HTMLBodyElement = this.scInstance["getBody"]();
        iframeBody.addEventListener('paste', lang.hitch(this, (ev: ClipboardEvent)=>{
            if (this.enableTextPasteFiltering){
                ev.stopImmediatePropagation();
                ev.preventDefault();
                const clipboardData = ev.clipboardData;
                let pastedTxt: string = clipboardData.getData("text");
                try {
                    pastedTxt = window["DOMPurify"]["sanitize"](pastedTxt);
                } catch {
                    //fallback
                    pastedTxt = pastedTxt.replaceAll(/<[^>]+>/g, '');
                }
                this.scInstance.insertText(pastedTxt);
            }
        }), true);
    }

    public editor_hide_fullscreen_button() {
        let fsb = this.domNode.getElementsByClassName("sceditor-button-maximize");
        for (let elem of fsb as any) {
            if ((elem as HTMLButtonElement).classList.contains("w3-hide") === false) {
                (elem as HTMLButtonElement).classList.add("w3-hide");
            }
        }
    }

    flagBlockFilter = false;
    //#region sc filter
    private SC_onInput() {
        if (this.flagBlockFilter === true) {
            return;
        }
        this.flagBlockFilter = true;
        //update von variablen
        this.inputHtmlContent.value = this.scInstance.val();
        this.htmlContentData = this.scInstance.val();
        // -------------------
        this.SChelper_elementListToCheck = [];
        try {
            if (this.scInstance.getBody().hasChildNodes) {
                for (let bElem of this.scInstance.getBody().children) {
                    this.SChelper_elementListToCheck.push(bElem);
                }
            }
        } catch (err) {
            console.warn(err);
        }
        this.SChelper_getAllChildNodes(this.SChelper_elementListToCheck);
        //#region filterlists
        //blacklists start
        let filteredAttributes = ['onafterprint', 'onbeforeprint', 'onbeforeunload', 'onerror', 'onhashchange', 'onload', 'onmessage', 'onoffline', 'ononline', 'onpagehide', 'onpageshow', 'onpopstate', 'onresize', 'onstorage', 'onunload', 'onblur', 'onchange', 'oncontextmenu', 'onfocus', 'oninput', 'oninvalid', 'onreset', 'onsearch', 'onselect', 'onsubmit', 'onkeydown', 'onkeypress', 'onkeyup', 'onclick', 'ondblclick', 'onmousedown', 'onmousemove', 'onmouseout', 'onmouseover', 'onmouseup', 'onmousewheel', 'onwheel', 'ondrag', 'ondragend', 'ondragenter', 'ondragleave', 'ondragover', 'ondragstart', 'ondrop', 'onscroll', 'oncopy', 'oncut', 'onpaste', 'onabort', 'oncanplay', 'oncanplaythrough', 'oncuechange', 'ondurationchange', 'onemptied', 'onended', 'onerror', 'onloadeddata', 'onloadedmetadata', 'onloadstart', 'onpause', 'onplay', 'onplaying', 'onprogress', 'onratechange', 'onseeked', 'onseeking', 'onstalled', 'onsuspend', 'ontimeupdate', 'onvolumechange', 'onwaiting', 'ontoggle'];
        let filteredHtmlTags = ['script', 'iframe', 'object', 'embed', 'meta', 'form', 'input', 'button', 'textarea', 'select', 'option', 'applet', 'base', 'basefont', 'bgsound', 'layer', 'title', 'frameset', 'frame', 'noframes', 'noscript', 'param', 'isindex', 'marquee'];
        //blacklists end
        let filterTheseTags: string[] = [];
        for (let elem of this.SChelper_elementListToCheck) {
            if (elem.tagName === "IMG") { //bereinigt bilder
                // Check if the image is already loaded
                if ((elem as HTMLImageElement).complete) {
                    this.SChelper_saniticeImage(elem as HTMLImageElement);
                } else {
                    // Image is not loaded, set the onload event handler
                    (elem as HTMLImageElement).onload = function (ev: any) {
                        this.SChelper_saniticeImage(ev.target);
                    }.bind(this);
                }
            }
            if (elem.tagName === "FONT") { //check ob die font verwendet werden darf
                if (elem.hasAttribute("face") || elem.hasAttribute("FACE")) {
                    let currentFont = (elem as HTMLFontElement).face;
                    if (currentFont.indexOf(",") != -1) {
                        currentFont = currentFont.split(",")[0];
                    }
                    let isAllowedFont = false;
                    for (let checkFont of this.editorOptionsAllowedFonts) {
                        if ((currentFont.toUpperCase()).indexOf(checkFont.toUpperCase()) != -1) {
                            isAllowedFont = true;
                        }
                    }
                    if (isAllowedFont === false) {
                        this.SChelper_stringFilterVal("face=\"" + (elem as HTMLFontElement).face + "\"", "face=\"" + this.editorOptionsAllowedFonts[0] + "\"");
                        (elem as HTMLFontElement).face = this.editorOptionsAllowedFonts[0];
                        console.warn("schriftart wurde geandert");
                    }
                }
            }
            //#region filter:font&Color
            if ((elem.tagName !== "FONT") && (elem.tagName !== "IMG")) {
                if ((elem.style.fontFamily as string).length > 0) { //aendert die schriftart
                    let currentFont = elem.style.fontFamily;
                    if (currentFont.indexOf(",") != -1) {
                        currentFont = currentFont.split(",")[0];
                    }
                    let isAllowedFont = false;
                    for (let checkFont of this.editorOptionsAllowedFonts) {
                        if ((currentFont.toUpperCase()).indexOf(checkFont.toUpperCase()) != -1) {
                            isAllowedFont = true;
                        }
                    }
                    if (isAllowedFont === false) {
                        elem.style.fontFamily = this.editorOptionsAllowedFonts[0];
                        //fonts auserhalb vom <font> tag werden jetzt einfacht blockiert, egal ob erlaubt oder nicht >:(
                        this.SChelper_stringFilterVal("font-family", "BLOCKEDfont-family");
                        console.warn("schriftart wurde geandert");
                    }
                }

                if ((elem.style.backgroundColor as string).length > 0) {
                    elem.style.backgroundColor = "transparent";
                    this.SChelper_stringFilterVal("background-color", "BLOCKEDbackground-color");
                    console.warn("text hintergrund farbe wurde entfernt");
                }
                if ((elem.style.background as string).length > 0) {
                    elem.style.background = "transparent";
                    this.SChelper_stringFilterVal("background", "BLOCKEDbackground");
                    console.warn("text hintergrund wurde entfernt");
                }
            }

            //#region general filter
            for (let filterMe of filteredHtmlTags) {
                if (elem.tagName === filterMe.toUpperCase()) {
                    try {
                        elem.outerHTML = "";
                        this.SChelper_stringFilterVal(elem.tagName, "div");
                        this.SChelper_stringFilterVal((elem.tagName as string).toLowerCase(), "div");
                        console.warn("removed potential dangerous html tag: " + filterMe)
                    } catch {
                        console.error("error removing potential dangerous tag!!");
                    }
                }
            }
            for (let filterMe of filteredAttributes) {
                try {
                    if (elem.hasAttribute(filterMe)) {
                        elem.removeAttribute(filterMe);
                        this.SChelper_stringFilterVal(filterMe, "BLOCK" + filterMe);
                        this.SChelper_stringFilterVal(filterMe.toUpperCase(), "BLOCK" + filterMe);
                        this.SChelper_stringFilterVal(filterMe.toLowerCase(), "BLOCK" + filterMe);
                        console.warn("removed potential dangerous html attribute: " + filterMe)
                    }
                } catch {
                    console.error("unable to remove or modify attributes for element " + elem.tagName + " with attribute " + filterMe);
                }
            }
            this.RenderText();
            this.flagBlockFilter = false;
        }
        this.SChelper_checkIfDirty();
        //sync values fuer is dirty
        this.inputHtmlContent.value = this.scInstance.val();
        this.htmlContentData = this.scInstance.val();
    }

    private SChelper_stringFilterVal(badString: string, goodString: string) {
        let curVal = this.scInstance.val();
        let oldVal = this.scInstance.val();
        curVal = curVal.replace(badString, goodString);
        this.htmlContentData = curVal;
        this.inputHtmlContent.value = curVal;
        this.scInstance.val(curVal);
        if (this.scInstance.val() !== oldVal) {
            //this.emit("popupWarning", "Potentielle Gefaehrliche Editor Wärte wurden raus gefilteret");
        }
    }

    private keydownEventTimeout;
    private _onBodyKeydown() {
        if (!this.keydownEventTimeout) {
            this.keydownEventTimeout = true;
            setTimeout(lang.hitch(this, this.SChelper_checkIfDirty), 1500);
        }
    }

    private SChelper_checkIfDirty() {
        this.keydownEventTimeout = false;
        let newVal = this.SCaditionFilter(this.scInstance.val());
        if (this.originalData !== this.scInstance.val()) { //check of editor inhalt geaendert wurde
            if (("<p>" + this.originalData + "</p>") != this.scInstance.val()) {//edgecase
                //update fuer die anderen widgets
                this.inputHtmlContent.value = newVal;
                this._onChange_InputValue({ target: this.inputHtmlContent });
                //emited dirty, da wir eine aenderung haben
                this.emit("dirty", true)
            }
        }
    }

    private SChelper_getAllChildNodes(inp: any) {
        for (let elem of inp as any) {
            if (elem.hasChildNodes() === true) {
                for (let childElem of elem.children as any) {
                    this.SChelper_elementListToCheck.push(childElem);
                }
                this.SChelper_getAllChildNodes(elem.children);
            }
        }
    }

    //#region sc filter img
    private SChelper_saniticeImage(image: HTMLImageElement) {
        var dataURLPattern = /^data:image\/[a-z]+;base64,/;
        if (dataURLPattern.test(image.src) === false) {
            // ersetzt das <img> mit shitty icon
            if ((image.src as string).length > 0) {
                let badSrc = image.src;
                let replaceSrc = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAGUExURf8bAPL/CpMiB0IAAAAJcEhZcwAADsEAAA7BAbiRa+0AAAA2SURBVBjTY2BsYGA6wMCSwMCjwCC5gUFwBoNhB4NiD0NiG4NjM8MBRobGRhBqYGT4/5+BgQEA988Lmxx0JsoAAAAASUVORK5CYII=';
                this.SChelper_stringFilterVal(badSrc, replaceSrc);
                image.src = replaceSrc;
                console.warn("bild link wurde gelöscht")
                return;
            }
        }
        // wenn das bild gar kein src hat, weil es bereits gefiltert wird, wird es geloescht
        if (image.hasAttribute("src") === false) {
            console.warn("leeres bild wurde gelöscht")
            //string filter funktioniert warscheinlich manchmal nicht, da scEditor manchmal/gerne attributes anders anordnet als im dom ist...
            this.SChelper_stringFilterVal(image.outerHTML, "");
            image.outerHTML = "";
            return;
        }
    }

    private SCaditionFilter(inputVal: string) {
        //fuer die zukunft *insert rainbow emoji*
        let newVal = inputVal
        return newVal;
    }

    //#region sc custom plugins
    private SChelper_AddCustomTooltips() {
        this.SChelper_AddCustomTooltipHeadings();
        this.SChelper_AddCustomTooltipClearEditor();
    }

    private SChelper_AddCustomTooltipClearEditor() {
        //@ts-expect-error
        sceditor.command.set('editorcleanup', {
            exec: function () {
                // clears editor
                this.val("");
            },
            tooltip: window.translations["email_MailForm_mailEditor_resetEditor"]
        });
        //@ts-expect-error
        sceditor.command.set('translate', {
            exec: lang.hitch(this, this.ScPlugin_TranslateClick),
            tooltip: this.getTranslation("TranslationsForm___Translate")
        });
    }


    //NOTE - der sch#!? SCeditor gibt im pluginEvent nur das button htmlElement mit das geclickt wurde
    //NOTE - deshalb habe ich den bundle code vom scEditor gepatched, damit er das event objekt durchreicht
    //NOTE - gl hf
    private ScPlugin_TranslateClick(pluginEvent:{source:HTMLElement, ev:MouseEvent}|HTMLElement){
        if (( typeof pluginEvent["source"] == 'undefined' ) || ( typeof pluginEvent["ev"] == 'undefined' ) ){
            console.error("scEditor does not pass mouse event...");
            this.showToast("SCeditor version miss-match!?", "fas fa-dumpster-fire");
            return;
        }

        let text = this.getScVal();
        if (typeof text != 'string') {
            console.error("cannot translate empty string!");
            return;
        }

        if (typeof this.translationLangSelectSourceLang != 'undefined') {
            try {
                this.translationLangSelectSourceLang.destroy();
            } catch { }
        }
        if (typeof this.translationLangSelectTargetLang != 'undefined'){
            try{
                this.translationLangSelectTargetLang.destroy();
            }catch{}
        }
        //select source language
        this.deepl_selectSourceLanguage(pluginEvent["ev"]); // deepl_selectSourceLanguage -> deepl_selectTargetLanguage -> DeepL_translateText
    }
    private deepl_selectSourceLanguage(ev:Event){
        let availableLanguages: Array<PitLanguageSuffix> = this.getCustomerSetting("allLanguages") ?? ["_D", "_E"];
        let entries: Array<object> = [];

        for (let langStr of availableLanguages) {
            if (langStr in PitLanguageMap) {
                let shortLangStr: string = PitLanguageMap[langStr];
                if (shortLangStr in CountryCodeIti) {
                    let flagPrefix = CountryCodeIti[shortLangStr];
                    if (shortLangStr in LanguagesGerman) {
                        let langNameFull = LanguagesGerman[shortLangStr];
                        entries.push({
                            callback: lang.hitch(this, this.deepl_selectTargetLanguage, shortLangStr),
                            label: langNameFull,
                            icon: "iti__flag center iti__" + flagPrefix
                        });
                    }
                }
            }
        }

        this.floatmenuDivContainer.innerHTML = "";
        this.translationLangSelectSourceLang = new FloatingMenu();
        this.translationLangSelectSourceLang.open(
            ev,
            entries as any,
            this.translate("email_MailForm_mailEditor_translate_floatmenu_heading_sourceLang"),
            this.floatmenuDivContainer
        );
    }

    private deepl_selectTargetLanguage(sourceLanguage:string, ev:Event){
        this.translationLangSelectSourceLang.close();
        let availableLanguages: Array<PitLanguageSuffix> = this.getCustomerSetting("allLanguages") ?? ["_D", "_E"];
        let entries: Array<object> = [];

        for (let langStr of availableLanguages) {
            if (langStr in PitLanguageMap) {
                let shortLangStr: string = PitLanguageMap[langStr];
                if (shortLangStr in CountryCodeIti) {
                    let flagPrefix = CountryCodeIti[shortLangStr];
                    if (shortLangStr in LanguagesGerman) {
                        let langNameFull = LanguagesGerman[shortLangStr];
                        entries.push({
                            callback: lang.hitch(this, this.DeepL_translateText, sourceLanguage, shortLangStr),
                            label: langNameFull,
                            icon: "iti__flag center iti__" + flagPrefix,
                            enabled: shortLangStr != sourceLanguage
                        });
                    }
                }
            }
        }

        this.floatmenuDivContainer.innerHTML = "";
        this.translationLangSelectTargetLang = new FloatingMenu();
        this.translationLangSelectTargetLang.open(
            ev,
            entries as any,
            this.translate("email_MailForm_mailEditor_translate_floatmenu_heading_targetLang"),
            this.floatmenuDivContainer
        );
    }

    private DeepL_translateText(sourceLanguage:string, targetLanguageCode: string){
        let text = this.getScVal();
        if (typeof text != 'string'){
            console.error("cannot translate empty string!");
            return;
        }
        let requestData = {
            SOURCELANG: CountryCode2[sourceLanguage],
            TARGETLANG: CountryCode2[targetLanguageCode],
            TEXT: encodeURI(text),
            TAGHANDLING: "html"
        };

        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API_DeepL__GetTranslation",
            requestData,
            lang.hitch(this, (res:any)=>{
                this.StandbyStop();
                console.info("translation result", res)
                if (typeof res["translationResult"] == 'string'){
                    this.scInstance.val(res["translationResult"]);
                    this.showToast({
                        title: this.translate("email_MailForm_mailEditor_translate_undo"),
                        iconClass:"fas fa-undo",
                        timeout: 60_000 * 15, //15 min, hat eh close button
                        options:{
                            onClick:()=>{
                                this.scInstance.val(text);
                            },
                            closeButton:true,
                        }
                    });
                }else{
                    console.error("invalid api response, cannot handle", res);
                    this.showToast("error_translating", "fas fa-bug");
                }
            }),
            lang.hitch(this, (er)=>{
                this.StandbyStop();
                console.error("deepl api error", er);
                this.showToast(er.Message, "fas fa-exclamation-circle");
            })
        );
    }
    private floatmenuDivContainer:HTMLDivElement;
    private translationLangSelectSourceLang:MdsLax<InstanceType<typeof FloatingMenu>>;
    private translationLangSelectTargetLang: MdsLax<InstanceType<typeof FloatingMenu>>;
    private SChelper_AddCustomTooltipHeadings() {
        // https://www.sceditor.com/posts/how-to-add-custom-commands
        //@ts-expect-error
        sceditor.command.set('headingspresets', {
            exec: function (caller: any) {
                // this is set to the editor instance
                let editor = this.scInstance;
                let content: HTMLDivElement = document.createElement("div");
                for (let i: number = 6; i >= 1; i--) {
                    let headerOption = document.createElement("a");
                    headerOption.className = "sceditor-headingspresets-option";
                    headerOption.href = "#";
                    let header = document.createElement("font");
                    //@ts-expect-error
                    header.size = i;
                    header.textContent = window.translations["email_MailForm_mailEditor_heading"] + " " + ((6 - i) + 1);
                    headerOption.classList.add("sceditor-fontsize-option");
                    headerOption.appendChild(header);
                    //headerOption.appendChild(document.createElement("br"))
                    headerOption.dataset.headersize = String(i);
                    headerOption.addEventListener("click", (ev) => {
                        //setzt das format
                        let rangeHelper = editor.getRangeHelper();
                        let currentRange: Range = rangeHelper.selectedRange()
                        if ((currentRange.startOffset == currentRange.endOffset) || currentRange === null) {
                            // when kein text markiert wurde, wird einfach text eingefuegt
                            let insertTxt = "<font size=\"" + (i) + "\"><b>";
                            insertTxt = insertTxt + window.translations["email_MailForm_mailEditor_heading"] + String(((6 - i) + 1));
                            insertTxt = insertTxt + "</b></font>"
                            editor.insert(insertTxt);
                        } else {
                            // wir ersetzen den text
                            let selectedContent: DocumentFragment = currentRange.cloneContents();
                            let selectedContentText = selectedContent.textContent;
                            let insertTxt = "<font size=\"" + (i) + "\"><b>";
                            insertTxt = insertTxt + selectedContentText + ((6 - i) + 1);
                            insertTxt = insertTxt + "</b></font>"
                            editor.insert(insertTxt);
                        }
                        try {
                            editor.closeDropDown(true);
                        } catch (err) {
                            console.error(err);
                        }
                        ev.preventDefault();
                    });
                    content.appendChild(headerOption);
                }
                editor.createDropDown(caller, "headingspresets", content);

            }.bind(this),

            tooltip: window.translations["email_MailForm_mailEditor_heading"],
        });
    }

    private SChelper_overWriteToolBoxButtonStyle() {
        //setzt den style fuer die toolbar buttons
        let buttonsList = this.domNode.querySelectorAll('.sceditor-dropdown input[type="button"]');
        if (buttonsList.length > 0) {
            for (let elem of buttonsList as any) {
                let target = elem as HTMLButtonElement;
                let addList = ["mds-button-base", "round", "hoverBright", "secondaryBG", "w3-medium"];
                for (let addMe of addList) {
                    if (target.classList.contains(addMe) == false) {
                        target.classList.add(addMe);
                    }
                }
            }
        }
    }

    //#region sc unload/load
    destroy() {
        try {
            if ((this.scDomObserver !== null) || (typeof this.scDomObserver !== 'undefined')) {
                this.scDomObserver.disconnect();
            }
            if (this.sceWasInitialized === true) {
                this.scInstance.destroy();
            }
        } catch {
            console.warn("cannot destroy sceditor")
        }
    }


    show() {
        this.flagEditorIsVisible = true;
        if (this.flagEditorExistsInDom === false) {
            // wird getriggered wenn ein nicht-dirty tab der nicht im fokus ist, geschlossen wird
            setTimeout(lang.hitch(this, () => {
                this.SCEditor_reload();
            }
            ), 50);
        }
    }

    close() {
        this.flagEditorIsVisible = false;
        // zerstoert den editor sauber
        if(this.scInstance) this.scInstance.destroy();
        this.flagEditorExistsInDom = false;
    }

    //#region initDependencys

    public async setupEditor() {


        await Promise.allSettled([
            //js
            ExtraHelpers.sideLoadResource(window.appRoot + "Content/sceditor/sceditor.js", 'js'), //ACHTUNG: wir verwnden un-minified version, da es mini-patches gibt im bundle code
            ExtraHelpers.sideLoadResource(window.appRoot + "Content/sceditor/misc_dependencys/purify.js", 'js'), //dompurify, zum paste sanitzizen, ACHTUNG: hat im loader header ein hotfix damit es mit dem dojo-loader nicht crashed
            //css
            await ExtraHelpers.sideLoadResource(window.appRoot + "Content/sceditor/base-theme_default.min.css", 'css'),
        ]);
        await Promise.allSettled([
            ExtraHelpers.sideLoadResource(window.appRoot + "Typescript/WidgetCollection/EMail/email.css", 'css'),
            //lang js
            ExtraHelpers.sideLoadResource(window.appRoot + "Content/sceditor/lang/de.js", 'js'),
            ExtraHelpers.sideLoadResource(window.appRoot + "Content/sceditor/lang/it.js", 'js'),
        ]);
    }

    SCEditor_reload(forceReload?: boolean) {
        if ((this.flagEditorIsVisible == true) || (forceReload == true)) {
            // tab in -> editor soll sichtbar sein, wir laden ihn rein
            if (this.sceWasInitialized == false) {
                this.SCloadEditor(); // erstes laden
            } else {
                // wenn bei einem isDirty tab der nicht im fokus ist und auf "x" gedrueckt wird, werden ansonsten 2 editor instancen im DOM erstellt
                if (this.flagEditorExistsInDom == false) {
                    try {
                        let scBody = (this.scInstance.getBody() as HTMLBodyElement);
                        scBody.removeEventListener("focusout", this.SC_onInput);
                    } catch { }
                    this.inputHtmlContent.style.display = "unset";
                    this.SChelper_AddCustomTooltips(); // muss die custom plugins neu laden
                    this.SCloadEditor();
                    this.flagEditorExistsInDom = true;
                }
            }
        }
    }

    public getScVal() {
        if (this.sceWasInitialized == true) {
            return this.scInstance.val();
        } else {
            return null;
        }
    }

    //#region fake border
    private editorBorderShow() {
        if (this.inputContainer.classList.contains("emailEditorFakeBorder") === false) {
            this.inputContainer.classList.add("emailEditorFakeBorder");
        }
    }

    private editorBorderHide() {
        if (this.inputContainer.classList.contains("emailEditorFakeBorder") === true) {
            this.inputContainer.classList.remove("emailEditorFakeBorder");
        }
    }

    //#region mark saved
    public markFormAsWasSaved() {
        if (this.sceWasInitialized == true) {
            this.originalData = JSON.parse(JSON.stringify(this.scInstance.val())); //deepcopy attempt
        }
    }

    //options

    _setEnableBorderAttr(newValue: string) {
        if ((newValue == null) && (typeof newValue === 'undefined')) {
            this.flagEnableFocusBorder = false; // default
            return;
        }
        if (newValue == "true") {
            this.flagEnableFocusBorder = true;
        }
        if (newValue == "false") {
            this.flagEnableFocusBorder = false;
        }
    }

    //#region sce hotfix
    private sce_observer_fix_multpl_inst = new MutationObserver(lang.hitch(this, (this as any).sce_prevent_multiple_editor_instances));

    private sce_prevent_multiple_editor_instances(){
        if ((typeof this.inputContainer != 'undefined') || (this.flagEditorExistsInDom == true)){
            if (this.inputContainer != null){
                let sceInstances = this.inputContainer.querySelectorAll("div.sceditor-container");
                if (sceInstances.length == 0){
                    this.SCEditor_reload();
                }
                if (sceInstances.length > 1){
                    this.SCEditor_reload();
                }
            }
        }
    }

    public helper_preventMultipleEditorInstancesCleanup(){
        this.sce_prevent_multiple_editor_instances();
    }

    public setShowTranslationButton(enable:boolean){
        this.showTranslationButton = enable;
        this.hasUserRoleAsync("WebTranslationsEditor").then((hasRole) => {
            let targetElem: HTMLDivElement = this.domNode.querySelector("div.sceditor-group a.sceditor-button-translate");
            if ((typeof targetElem == 'undefined') || (targetElem == null)){
                return; //life-time fun
            }
            targetElem = targetElem.parentNode as HTMLDivElement;
            if (hasRole == true) {
                if (enable) {
                    targetElem.classList.remove("w3-hide");
                } else {
                    targetElem.classList.add("w3-hide");
                }
            }else{
                //no role, immer false
                targetElem.classList.add("w3-hide");
            }
        });
    }
}

export default mdsWidget(HtmlEditor);
